// extracted by mini-css-extract-plugin
export default {"no-notifications":"no-notifications__DupXu","text":"text__XmQAU"};